import { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Button,
	Col,
	Input,
	Row,
	Typography,
	Form,
	Select,
	DatePicker,
	TimePicker,
} from "antd";
import dayjs from "dayjs";
import { toast } from "react-toastify";
import { loadAllStaff } from "../../redux/rtk/features/user/userSlice";
import {
	addManualAttendance,
	loadAllAttendance,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import GetAllAttendance from "./GetAllAttendance";
import UserPrivateComponent from "../PrivateRoutes/UserPrivateComponent";

const Attendance = ({ drawer }) => {
	const [loader, setLoader] = useState(false);
	const [inTimeDate, setInTimeDate] = useState({
		time: null,
		date: null,
	});
	const [outTimeDate, setOutTimeDate] = useState({
		time: null,
		date: null,
	});

	const users = useSelector((state) => state.users?.list);
	const user = useSelector((state) => state.users?.user); // logged-in admin
	const dispatch = useDispatch();
	const { Title } = Typography;
	const [form] = Form.useForm();

	// ✅ Hooks must be above any return
	useEffect(() => {
		dispatch(loadAllStaff({ status: true }));
	}, [dispatch]);

	// Create proper Date objects safely
	const inTimeDateNew =
		inTimeDate.date && inTimeDate.time
			? new Date(`${inTimeDate.date} ${inTimeDate.time}`)
			: null;

	const outTimeDateNew =
		outTimeDate.date && outTimeDate.time
			? new Date(`${outTimeDate.date} ${outTimeDate.time}`)
			: null;

	const onFinish = async (values) => {
		const FormData = {
			...values,
			inTime: inTimeDateNew instanceof Date && !isNaN(inTimeDateNew)
				? inTimeDateNew
				: null,
			outTime: outTimeDateNew instanceof Date && !isNaN(outTimeDateNew)
				? outTimeDateNew
				: null,
			punchBy: {
				id: localStorage.getItem("userId"),
				firstName: localStorage.getItem("username"),
				lastName: "",
			},
		};

		setLoader(true);
		const resp = await dispatch(addManualAttendance(FormData));

		if (resp?.payload?.message === "success") {
			form.resetFields();
			setInTimeDate({ time: null, date: null });
			setOutTimeDate({ time: null, date: null });
			dispatch(loadAllAttendance());
		} else {
			toast.error("Failed to add attendance");
		}

		setLoader(false);
	};

	const onFinishFailed = () => {
		toast.warning("Failed at adding shift");
		setLoader(false);
	};

	// ✅ RETURN after all hooks
	const isLogged = localStorage.getItem("isLogged");

	if (!isLogged) return <p>Please login again</p>;	


	return (
		<Fragment>
			<UserPrivateComponent permission={"create-attendance"}>
				<Row className='mr-top' justify={drawer ? "center" : "space-between"}>
					<Col
						xs={24}
						sm={24}
						md={24}
						lg={drawer ? 22 : 12}
						xl={drawer ? 22 : 12}
						className='column-design border rounded card-custom'>
						<Title level={4} className='m-2 mt-5 mb-5 text-center'>
							Add Manual Attendance
						</Title>

						{!inTimeDateNew || !outTimeDateNew ? (
							<p className='text-center text-rose-500 text-sm font-medium mb-4'>
								* Please fill Date and Time
							</p>
						) : null}

						<Form
							form={form}
							style={{ marginBottom: "40px" }}
							name='basic'
							labelCol={{ span: 6 }}
							wrapperCol={{ span: 12 }}
							onFinish={onFinish}
							onFinishFailed={onFinishFailed}
							autoComplete='off'>
							<div>
								<Form.Item
									style={{ marginBottom: "10px" }}
									label='User'
									name='username'
									rules={[
										{
											required: true,
											message: "Please select user!",
										},
									]}>
									<Select placeholder='Select User'>
									
  										{users?.length > 0 ? (
    										users.map((u) => (
      											<Select.Option key={u._id} value={u.username}>
        											{u.username}
      											</Select.Option>
    										))
  										) : (
    										<Select.Option disabled>No users found</Select.Option>
  										)}

									</Select>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Start Time'>
									<div className='flex justify-between'>
										<DatePicker
											format={"YYYY-MM-DD"}
											onChange={(date, dateString) =>
												setInTimeDate({
													...inTimeDate,
													date: dateString,
												})
											}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm:ss"}
											onChange={(time, timeString) =>
												setInTimeDate({
													...inTimeDate,
													time: timeString,
												})
											}
										/>
									</div>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='End Time'>
									<div className='flex justify-between'>
										<DatePicker
											format={"YYYY-MM-DD"}
											onChange={(date, dateString) =>
												setOutTimeDate({
													...outTimeDate,
													date: dateString,
												})
											}
										/>
										<TimePicker
											className='ml-4'
											format={"HH:mm:ss"}
											onChange={(time, timeString) =>
												setOutTimeDate({
													...outTimeDate,
													time: timeString,
												})
											}
										/>
									</div>
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='Comment'
									name='comment'>
									<Input placeholder='Comment' />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									label='IP Address'
									name='ip'>
									<Input placeholder='127.0.0.1' />
								</Form.Item>

								<Form.Item
									style={{ marginBottom: "10px" }}
									wrapperCol={{
										offset: 6,
										span: 12,
									}}>
									<Button
										type='primary'
										size='large'
										disabled={!inTimeDateNew || !outTimeDateNew}
										htmlType='submit'
										block
										loading={loader}>
										Add Attendance
									</Button>
								</Form.Item>
							</div>
						</Form>
					</Col>
				</Row>
			</UserPrivateComponent>

			<UserPrivateComponent permission={"readAll-attendance"}>
				<GetAllAttendance />
			</UserPrivateComponent>
		</Fragment>
	);
};

export default Attendance;